// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"a6c44dbe","455":"b33fc749","977":"240addac"}[chunkId] + ".chunk.js";
};